/**
 * URL search param used when navigating from notification card "Settings" to the
 * settings page so the edit subscription modal opens automatically. Shared by
 * notifications (where the link is built) and settings (where the param is read).
 */
export const EDIT_SUBSCRIPTION_SEARCH_PARAM = 'editSubscription';
